/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { AppLayout } from '@veeam/components';
import { observer } from 'mobx-react-lite';

import { PortalHeader } from '../../PortalHeader';
import { BaseLayout } from '../BaseLayout';
import { useGlobalAppData } from '../../providers/GlobalContextProvider';
import { PortalBodyLayout } from '../PortalBodyLayout';

import type { AppRouteItem } from '../../../stores/router';

export interface PortalLayoutProps {
    currentPath: string;
    items: AppRouteItem[];
    children?: React.ReactElement;

    header?: React.ReactElement;
    customPortalBody?: React.ReactElement;
    onLoginButtonClick?: () => void;
}

export const PortalLayout: React.FC<PortalLayoutProps> = observer((props) => {
    const { currentPath, items, children, header, customPortalBody, onLoginButtonClick } = props;
    const { appMinWidth } = useGlobalAppData();

    return (
        <BaseLayout onLoginButtonClick={onLoginButtonClick}>
            <AppLayout
                header={header ?? <PortalHeader />}
                minWidth={appMinWidth}
                body={customPortalBody ?? (
                    <PortalBodyLayout
                        currentPath={currentPath}
                        items={items}
                    >
                        {children}
                    </PortalBodyLayout>
                )}
            />
        </BaseLayout>
    );
});
